/**
 * linkify — turn URLs inside a plain-text string into clickable <a> tags.
 * Preserves line-breaks (newlines rendered as-is by parent whitespace-pre-wrap
 * container). Handles http://, https://, and bare "www." prefixes.
 *
 * Usage:  <div className="whitespace-pre-wrap break-words">{linkify(text)}</div>
 */
import React from "react";

// Match http(s):// URLs OR bare www.domain… tokens. Stops at whitespace.
const URL_RE = /((?:https?:\/\/|www\.)[^\s<>()[\]]+[^\s<>()[\]!.,;:'"])/gi;

export function linkify(input) {
  if (!input) return input;
  const text = String(input);
  const parts = [];
  let lastIndex = 0;
  let match;
  URL_RE.lastIndex = 0;
  while ((match = URL_RE.exec(text)) !== null) {
    const start = match.index;
    const end = start + match[0].length;
    if (start > lastIndex) parts.push(text.slice(lastIndex, start));
    const raw = match[0];
    const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
    parts.push(
      <a
        key={`${start}-${end}`}
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        className="text-[#F54800] hover:underline break-all"
        onClick={(e) => e.stopPropagation()}
      >
        {raw}
      </a>
    );
    lastIndex = end;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts.length > 1 ? parts : text;
}

export default linkify;
